import { makeRequest } from './https';
import { isDemoMode } from '../demo/demoMode';
import { 
  CreatePreSignedUrlRequest, 
  CreatePreSignedUrlResponse, 
  FileType, 
  FileExtension 
} from '../types/upload.type';

export const generatePresignedUrl = (
  data: CreatePreSignedUrlRequest, 
  fileType: FileType, 
  fileExtension: FileExtension
): Promise<CreatePreSignedUrlResponse> => {
  return makeRequest({
    url: '/upload',
    method: 'post',
    data,
    params: {
      file_type: fileType,
      file_extension: fileExtension
    }
  });
};

// Add the mobile-compatible function
export const createPresignedUrl = (
  fileType: FileType,
  fileExtension: FileExtension,
  data: CreatePreSignedUrlRequest
): Promise<CreatePreSignedUrlResponse> => {
  return makeRequest({
    url: `/upload?file_type=${fileType}&file_extension=${fileExtension}`,
    method: 'post',
    data,
  });
};

export const uploadFileToPresignedUrl = async (
  file: File | Blob, 
  presignedUrl: string,
  contentType?: string,
  fileName?: string
): Promise<void> => {
  // Demo mode: skip the real upload to the (fake) presigned URL.
  if (isDemoMode()) {
    return;
  }
  try {
    const response = await fetch(presignedUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': contentType || (file instanceof File ? file.type : 'audio/webm'),
      },
      body: file,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Upload failed: ${response.status} ${response.statusText} - ${errorText}`);
    }
  } catch (error) {
    throw error;
  }
}; 